import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  
  const [email, setEmail] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      const response = await fetch('https://readdy.ai/api/form/d66rtriud6iuf6if0uqg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        alert('ご登録ありがとうございます！');
        setEmail('');
      } else {
        alert('エラーが発生しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('エラーが発生しました。もう一度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0e27] text-white font-sans">
      {/* Header */}
      

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-radial from-[#1a1f3a] via-[#0a0e27] to-[#0a0e27]"></div>
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(0deg, rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#00d4ff]/5 rounded-full blur-[200px]"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-8 lg:px-12 py-20 w-full">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-8 lg:pl-12">
              <div className="text-[12px] font-semibold tracking-[3px] text-[#00d4ff] uppercase">
                / REGIME-BASED EA LABORATORY
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight" style={{ textShadow: '0 2px 20px rgba(0,212,255,0.3)' }}>
                最新情報は価値。<br />検証は資産。
              </h1>
              <p className="text-lg text-[#b8c5d6] leading-relaxed max-w-[520px]">
                レジーム可視化 + 根拠/反証/ガードを毎日記録。<br />
                透明性のある運用ログで、完璧な投資マシーンを構築する。
              </p>
              <div className="space-y-6 max-w-[380px]">
                <a href="#ea" className="flex items-center justify-between h-14 px-6 bg-gradient-to-br from-[#ffd700] to-[#ffaa00] rounded-lg text-[#0a0e27] text-base font-bold hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#ffd700]/30 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <i className="ri-download-line text-xl"></i>
                    <span>無料EAを見る</span>
                  </div>
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
                <a href="#daily" className="flex items-center justify-between h-14 px-6 border-2 border-[#00d4ff] rounded-lg text-[#00d4ff] text-base font-semibold hover:bg-[#00d4ff]/10 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <i className="ri-file-text-line text-xl"></i>
                    <span>無料の日次（簡易版）を見る</span>
                  </div>
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
                <a href="#plans" className="flex items-center justify-between h-14 px-6 border border-[#b8c5d6]/30 rounded-lg text-[#b8c5d6] text-[15px] font-medium hover:border-[#b8c5d6] transition-all duration-300 cursor-pointer whitespace-nowrap">
                  <span>プランを見る</span>
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
            </div>

            {/* Right Visual */}
            <div className="hidden lg:block relative">
              <div className="relative" style={{ transform: 'perspective(1200px) rotateY(-3deg)' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_b81cc0ab04653eeba667f03c1e8a1cf5_831e27af.jpg"
                  alt="Dashboard"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                  style={{
                    maskImage: 'radial-gradient(ellipse 90% 90% at center, black 40%, transparent 100%)',
                    WebkitMaskImage: 'radial-gradient(ellipse 90% 90% at center, black 40%, transparent 100%)'
                  }}
                />
                <div className="absolute -top-8 -left-8 w-72 h-52 bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-7 animate-float">
                  <div className="text-base text-[#00d4ff] font-semibold tracking-wider uppercase mb-3">Regime</div>
                  <div className="text-5xl font-bold">RISK-ON</div>
                  <div className="text-xl text-[#b8c5d6] mt-3">Confidence: 78%</div>
                </div>
                <div className="absolute -bottom-6 -right-6 w-72 h-52 bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-7 animate-float-delayed">
                  <div className="text-base text-[#00d4ff] font-semibold tracking-wider uppercase mb-3">Volatility</div>
                  <div className="text-5xl font-bold">12.3</div>
                  <div className="text-xl text-[#b8c5d6] mt-3">Low Range</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ticker */}
      <section className="bg-[#1a1f3a]/60 h-20 overflow-hidden relative border-t border-white/5">
        <div className="flex items-center h-full animate-marquee whitespace-nowrap">
          <div className="flex items-center gap-12 px-12">
            <span className="text-sm text-[#b8c5d6]">USD/JPY 149.23 <span className="text-[#00ff88]">▲0.45%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">S&P500 4,782 <span className="text-[#ff4466]">▼0.12%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">VIX 13.8</span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">US10Y 4.25%</span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">EUR/USD 1.0845 <span className="text-[#00ff88]">▲0.23%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">GOLD 2,048 <span className="text-[#00ff88]">▲0.67%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">USD/JPY 149.23 <span className="text-[#00ff88]">▲0.45%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">S&P500 4,782 <span className="text-[#ff4466]">▼0.12%</span></span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">VIX 13.8</span>
            <span className="text-[#b8c5d6]">/</span>
            <span className="text-sm text-[#b8c5d6]">US10Y 4.25%</span>
          </div>
        </div>
      </section>

      {/* Market Snapshot */}
      <section id="daily" className="py-32 relative">
        <div className="max-w-[1200px] mx-auto px-8 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">Today's Market Snapshot</h2>
            <div className="w-32 h-1 bg-[#00d4ff] mx-auto"></div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'REGIME', value: 'RISK-ON', sub: 'Confidence: 78%', glow: 'from-green-500/10' },
              { title: 'VOLATILITY', value: '12.3', sub: 'Low Range', glow: 'from-orange-500/10' },
              { title: 'RATES TREND', value: '↑ Rising', sub: 'US10Y +0.15%', glow: 'from-blue-500/10' },
              { title: 'CONFIDENCE', value: '78%', sub: 'High Certainty', glow: 'from-purple-500/10' }
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-gradient-to-br from-[#1a1f3a]/80 to-[#0a0e27]/90 border border-[#00d4ff]/20 rounded-2xl p-8 hover:border-[#00d4ff] hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="text-xs font-semibold tracking-[2px] text-[#00d4ff] uppercase mb-4">{item.title}</div>
                <div className="text-3xl font-bold mb-2">{item.value}</div>
                <div className="text-sm text-[#b8c5d6]">{item.sub}</div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <p className="text-sm text-[#b8c5d6]/70 italic">※ 完全版では各因子の内訳・根拠・反証まで公開</p>
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="py-36 relative">
        <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="100" height="100" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noise"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="4" /%3E%3C/filter%3E%3Crect width="100" height="100" filter="url(%23noise)" opacity="0.5"/%3E%3C/svg%3E")' }}></div>
        <div className="relative max-w-[1400px] mx-auto px-8 lg:px-12">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">EA-labが提供する3つの価値</h2>
            <p className="text-lg text-[#b8c5d6]">透明性・再現性・継続改善を実現する仕組み</p>
          </div>
          <div className="grid md:grid-cols-3 gap-16">
            {[
              {
                icon: 'ri-line-chart-line',
                title: 'レジーム判定',
                desc: 'ニュース・金利・指数・ボラティリティを統合し、相場環境を『局面』として可視化。どのEAが有効かを判断する基盤を提供。'
              },
              {
                icon: 'ri-search-eye-line',
                title: '根拠 + 反証（Explainability）',
                desc: 'なぜこのEAを選んだのか、どの条件で無効化するのか。根拠と反証を毎日記録し、運用の透明性を確保。'
              },
              {
                icon: 'ri-arrow-up-line',
                title: '運用改善（検証ログ）',
                desc: '日次・月次レポートで検証結果を蓄積。失敗も含めて公開し、継続的な改善サイクルを回す。'
              }
            ].map((item, idx) => (
              <div key={idx} className="text-center">
                <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#00d4ff]/10 flex items-center justify-center">
                  <i className={`${item.icon} text-4xl text-[#00d4ff]`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
                <p className="text-base text-[#b8c5d6] leading-relaxed max-w-[320px] mx-auto">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Archive Rule */}
      <section className="py-32 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-[#00d4ff]/3 to-transparent"></div>
        <div className="relative max-w-[1200px] mx-auto px-8 lg:px-12">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">情報公開のルール</h2>
            <p className="text-base text-[#b8c5d6]">最新情報は価値。30日後はアーカイブとして公開。</p>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-8">
            {/* Stage 1 */}
            <div className="text-center">
              <div className="w-28 h-28 mx-auto rounded-full bg-white/10 border-2 border-[#b8c5d6] flex items-center justify-center mb-4">
                <div>
                  <div className="text-xl font-bold">Day 0</div>
                </div>
              </div>
              <div className="text-sm font-semibold text-[#b8c5d6] mb-2">日次簡易版</div>
              <div className="text-xs text-[#b8c5d6]/70">無料公開</div>
            </div>

            {/* Arrow */}
            <div className="hidden lg:block">
              <div className="w-20 h-0.5 bg-[#00d4ff]/50 relative">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-8 border-l-[#00d4ff]/50"></div>
              </div>
            </div>

            {/* Stage 2 - Pro */}
            <div className="text-center">
              <div className="relative">
                <div className="w-32 h-32 mx-auto rounded-full bg-gradient-to-br from-[#ffd700]/20 to-[#ffaa00]/20 border-3 border-[#ffd700] flex flex-col items-center justify-center mb-4 shadow-[0_0_40px_rgba(255,215,0,0.3)]">
                  <div className="text-xs text-[#b8c5d6] mb-1">Day 0</div>
                  <div className="text-2xl font-bold text-[#ffd700]">Pro</div>
                </div>
              </div>
              <div className="text-base font-semibold mb-2">最新完全版</div>
              <div className="text-xs text-[#b8c5d6]">因子内訳・根拠・反証すべて公開</div>
            </div>

            {/* Arrow */}
            <div className="hidden lg:block">
              <div className="w-20 h-0.5 bg-[#00d4ff]/50 relative">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-8 border-l-[#00d4ff]/50"></div>
              </div>
            </div>

            {/* Stage 3 */}
            <div className="text-center">
              <div className="w-28 h-28 mx-auto rounded-full bg-[#00d4ff]/10 border-2 border-[#00d4ff] flex flex-col items-center justify-center mb-4">
                <div className="text-xs text-[#b8c5d6] mb-1">Day 30+</div>
                <div className="text-xl font-bold text-[#00d4ff]">Lite</div>
              </div>
              <div className="text-sm font-semibold text-[#b8c5d6] mb-2">完全版アーカイブ</div>
              <div className="text-xs text-[#b8c5d6]/70">30日経過後に公開</div>
            </div>
          </div>
          <div className="text-center mt-16">
            <p className="text-sm text-[#b8c5d6]/70 max-w-[800px] mx-auto">
              ※ 最新情報ほど価値が高いため、Proプランで即時アクセス可能。Liteは過去ログの学習に最適。
            </p>
          </div>
        </div>
      </section>

      {/* Plans */}
      <section id="plans" className="py-36 relative">
        <div className="absolute inset-0 bg-gradient-to-bl from-[#1a1f3a]/50 to-transparent"></div>
        <div className="relative max-w-[1400px] mx-auto px-8 lg:px-12">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">プランを選ぶ</h2>
            <p className="text-lg text-[#b8c5d6]">あなたの運用スタイルに合わせて</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 items-center">
            {/* Free */}
            <div className="bg-gradient-to-br from-[#1a1f3a]/90 to-[#0a0e27]/95 border border-white/10 rounded-3xl p-10 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-3xl font-bold text-center mb-6">Free</h3>
              <div className="text-center mb-8">
                <div className="text-5xl font-bold">¥0</div>
                <div className="text-lg text-[#b8c5d6] mt-2">円/月</div>
              </div>
              <div className="space-y-5 mb-10">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">日次簡易版（無料）</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">無料EA一覧</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-xl text-[#ff4466]/50 mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]/40">完全版アーカイブ</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-xl text-[#ff4466]/50 mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]/40">最新完全版</span>
                </div>
              </div>
              <button className="w-full h-12 border border-[#b8c5d6] rounded-lg text-[#b8c5d6] font-semibold hover:bg-[#b8c5d6]/10 transition-all duration-300 cursor-pointer whitespace-nowrap">
                今すぐ始める
              </button>
            </div>

            {/* Lite */}
            <div className="bg-gradient-to-br from-[#1a1f3a]/90 to-[#0a0e27]/95 border border-white/10 rounded-3xl p-10 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-3xl font-bold text-center mb-6">Lite</h3>
              <div className="text-center mb-8">
                <div className="text-5xl font-bold">¥1980</div>
                <div className="text-lg text-[#b8c5d6] mt-2">円/月</div>
              </div>
              <div className="space-y-5 mb-10">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">日次簡易版</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">無料EA一覧</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">完全版アーカイブ（30日経過分）</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-xl text-[#ff4466]/50 mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]/40">最新完全版</span>
                </div>
              </div>
              <button className="w-full h-12 bg-[#00d4ff] rounded-lg text-black font-semibold hover:brightness-110 transition-all duration-300 cursor-pointer whitespace-nowrap">
                Liteを選ぶ
              </button>
            </div>

            {/* Pro */}
            <div className="relative bg-gradient-to-br from-[#1a1f3a]/90 to-[#0a0e27]/95 border border-white/10 rounded-3xl p-10 lg:scale-110 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#ffd700] text-black text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap">
                RECOMMENDED
              </div>
              <h3 className="text-3xl font-bold text-center mb-6 text-[#ffd700]">Pro</h3>
              <div className="text-center mb-8">
                <div className="text-5xl font-bold">¥6,980</div>
                <div className="text-lg text-[#b8c5d6] mt-2">円/月</div>
              </div>
              <div className="space-y-5 mb-10">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">日次簡易版</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">無料EA一覧</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">完全版アーカイブ</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">最新完全版（因子内訳・根拠・反証）</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-[#00ff88] mt-0.5"></i>
                  <span className="text-[15px] text-[#b8c5d6]">月次レポート優先アクセス</span>
                </div>
              </div>
              <button className="w-full h-12 bg-gradient-to-br from-[#ffd700] to-[#ffaa00] rounded-lg text-black font-bold hover:brightness-110 hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap">
                Proを選ぶ
              </button>
            </div>
          </div>
        </div>
      </section>

      

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 4s ease-in-out infinite;
          animation-delay: 1s;
        }
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .bg-gradient-radial {
          background: radial-gradient(ellipse at top, #1a1f3a 0%, #0a0e27 60%);
        }
      `}</style>
    </div>
  );
}
